import styled, { css } from "styled-components";

import { IS_SMALL, MEDIA_NO_TOUCH } from "~/utils/media";
import { Body, SmallHeadline } from "~/components/typography";

const CUSTOM_CSS = {
  simple: css`
    padding-top: 0;
  `,
  script: css`
    padding-bottom: 0.5rem;
  `,
  childsPlay: css`
    padding-bottom: 0.65rem;
  `,
  teen: css`
    padding-bottom: 0.3rem;
  `,
};

export const MessageWrapper = styled.div`
  position: relative;
  right: 35%;
  display: flex;
  flex-direction: row;
  margin-bottom: 8rem;

  ${IS_SMALL} {
    right: 0;
    flex-direction: column;
    margin-bottom: 6rem;
  }
`;

export const MessageHeadline = styled.div`
  ${Body} {
    width: 50vw;
    max-width: 480px;
  }

  ${IS_SMALL} {
    ${Body} {
      width: auto;
      max-width: none;
    }
  }
`;

export const OpenCardWrapper = styled.div`
  display: flex;
  width: 100%;
  box-shadow: ${({ theme }) => theme.custom.shadows.three};

  ${IS_SMALL} {
    position: relative;
    left: -80%;
    width: 180%;
    margin-bottom: 2rem;
  }
`;

export const MessagePlaceholder = styled.div`
  pointer-events: none;
  position: absolute;
  z-index: 1;
  top: calc(10% - 1rem);
  left: 10%;
  color: ${({ theme }) => theme.colors.secondary};
  touch-callout: none;
  user-select: none;
  white-space: break-spaces;
  opacity: 0.4;
`;

export const MessageSide = styled.div`
  position: relative;
  flex-grow: 1;
  padding-top: calc(50% * (5.5 / 4.25));

  textarea {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 10%;
    outline: none;
    border: none;
    resize: none;

    &::placeholder {
      color: ${({ theme }) => theme.colors.secondary};
    }
  }

  textarea,
  ${MessagePlaceholder} {
    ${({ theme }) => theme.typography.heroBody};
    ${({ $font, theme }) => $font && theme.typography[$font]};
  }

  &:first-child {
    background-color: ${({ theme }) => theme.colors.neutral};
    background: linear-gradient(
      to right,
      transparent 60%,
      rgba(0,0,0, 0.05) 100%
    );
  }
`;

export const MessageOptions = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  width: calc(35% - 2rem);
  height: 100%;
  margin-left: 2rem;

  ${SmallHeadline} {
    position: sticky;
    top: -1px;
    margin-bottom: 0.5rem;
    padding: 0 0 0.5rem 4px;
    color: ${({ theme }) => theme.colors.accentTwo};
    background-color: ${({ theme }) => theme.colors.white};
    text-transform: uppercase;
  }

  ${IS_SMALL} {
    position: sticky;
    top: auto;
    bottom: 2rem;
    left: auto;
    width: auto;
    margin: 0;
    margin-left: -1rem;
    white-space: nowrap;

    ${SmallHeadline} {
      margin-left: 1rem;
      margin-bottom: 0;
      background-color: transparent;
    }
  }
`;

export const MessageOption = styled.button`
  cursor: pointer;
  display: block;
  height: 64px;
  width: 100%;
  margin-bottom: 0.5rem;
  padding: 0.75rem 1rem;
  text-align: left;
  color: ${({ theme }) => theme.colors.secondary};
  background-color: ${({ theme }) => theme.colors.white};
  border: 2px solid ${({ theme }) => theme.colors.neutral};
  border-radius: 8px;
  appearance: none;
  outline: none;

  ${({ $font, theme }) =>
    $font &&
    css`
      ${theme.typography[$font]};
      ${CUSTOM_CSS?.[$font]};
    `
  }

  ${({ $isActive }) => $isActive && css`
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.accentTwo};
    border-color: ${({ theme }) => theme.colors.accentTwo};
  `};

  ${MEDIA_NO_TOUCH} {
    &:hover {
      ${({ $isActive }) => !$isActive && css`
        color: ${({ theme }) => theme.colors.secondary};
        background-color: ${({ theme }) => theme.colors.neutral};
      `}
    }
  }

  ${IS_SMALL} {
    display: inline-block;
    width: auto;
    margin-right: 0.5rem;

    &:first-of-type {
      margin-left: 1rem;
    }
  }
`;

export const MessageOptionScroll = styled.div`
  overflow: auto;
  position: relative;
  flex-grow: 1;
  margin-right: -1rem;
  padding-right: 1rem;
  padding-bottom: 4rem;
  mask-image: linear-gradient(
    to bottom,
    rgb(0, 0, 0) 86%,
    transparent 100%
  );

  ${IS_SMALL} {
    display: flex;
    margin-bottom: 0.5rem;
    padding-bottom: 0.5rem;
    mask-image: none;
  }
`;

export const MessageStickyWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const MessageControls = styled.div`
  position: sticky;
  bottom: 1rem;
  display: flex;
  flex-direction: column;
  margin: 0 -1rem -1rem;
  padding: 2rem;
  background-color: ${({ theme }) => theme.colors.accentOne};
  border-radius: 24px;
  border-bottom-right-radius: 0;

  ${IS_SMALL} {
    position: relative;
    bottom: auto;
    margin-right: 0;
    margin-left: 1rem;
    padding: 1rem 2rem;
  }
`;
